import React, { createContext, useState, useEffect, useContext } from 'react';
import cartService from '../service/cartService';
import { useAuth, AuthContext } from './AuthContext';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
 const { user } = useAuth(); // get logged-in user
//const { user } = useContext(AuthContext);
  const [cart, setCart] = useState(() => {
    const storedCart = localStorage.getItem('cart');
    return storedCart ? JSON.parse(storedCart) : [];
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const loadCartFromServer = async () => {
    if (!user || !user.userId) return;  // No user, skip

    try {
      // Pass userId to your service method
      const response = await cartService.getCarts(user.userId);
      setCart(response.data || []);
       // console.log("server load context  ", cart);
    } catch (error) {
      console.error('Error loading cart:', error);
    }
  };

  return (
    <CartContext.Provider value={{ cart, setCart, loadCartFromServer }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
